import Axios from 'axios'
import React, { useState, useEffect, useRef, useImperativeHandle, forwardRef, useMemo } from 'react'
import '../../assets/scss/dropdown.scss'
import loader from '../../assets/img/loader.svg'
import Api from '../../_helpers/Api'
import { trans } from '../../_providers/Translation'
import { createPortal } from "react-dom"
import { Avatar, AvatarGroup, Checkbox } from '@mui/material'
import { pink } from '@mui/material/colors'
import Skeleton from 'react-loading-skeleton'

function useOnClickOutside(ref, handler) {
    useEffect(
        () => {
            const listener = (event) => {
                // Do nothing if clicking ref's element or descendent elements
                if (!ref.current || ref.current.contains(event.target)) {
                    return
                }
                handler(event)
            }
            document.addEventListener("mousedown", listener)
            document.addEventListener("touchstart", listener)
            return () => {
                document.removeEventListener("mousedown", listener)
                document.removeEventListener("touchstart", listener)
            }
        },
        // Add ref and handler to effect dependencies
        // It's worth noting that because passed in handler is a new ...
        // ... function on every render that will cause this effect ...
        // ... callback/cleanup to run every render. It's not a big deal ...
        // ... but to optimize you can wrap handler in useCallback before ...
        // ... passing it into this hook.
        [ref, handler]
    )
}

function Index(props, ref) {
    const inputRef = useRef(null)
    const dropdownContainerRef = useRef(null)
    const dropdownRef = useRef(null)
    const listRef = useRef(null)

    const variant = props.variant || 'floatingLabel'
    const size = props.size || ''
    const position = props.position || 'left'
    const filter = Boolean(props.filter) || false
    const filterTimeout = props.timeout || 600
    const inputName = props.inputName || 'text-value'
    const inputValue = props.inputValue || ''
    const inputIdField = props.inputIdField || 'id'
    const inputId = props.inputId || ''
    const inputClassName = props.inputClassName || ''
    const inputIdName = props.inputIdName || 'id-value'
    const inputIdValue = props.inputIdValue || ''
    const inputPlaceholder = props.inputPlaceholder || ''
    const inputReadOnly = props.inputReadOnly || false
    const inputDisabled = props.inputDisabled || false
    const dropdownData = Array.isArray(props.data) ? props.data : []
    const dataUrl = props.url || null
    const dataKeyword = props.keyword || 'name'
    const dataParams = props.params || {}
    const loadDataOnFocus = props.loadDataOnFocus || false
    const requiredParams = Array.isArray(props.requiredParams) ? props.requiredParams : []
    const renderText = props.renderText || ''
    const renderInputText = props.renderInputText || ''
    const filterable = typeof props.filterable !== 'undefined' ? Boolean(props.filterable) : true
    const multiple = typeof props.multiple !== 'undefined' ? Boolean(props.multiple) : false
    const selectedValues = Array.isArray(props.selectedValues) ? props.selectedValues : []
    const selectedIds = Array.isArray(props.selectedIds) ? props.selectedIds : []
    const withSelectedList = typeof props.withSelectedList !== 'undefined' ? props.withSelectedList : false
    const addButtonDisabled = Boolean(props.addButtonDisabled) || false
    const onClickAddButton = typeof props.onClickAddButton === 'function' ? props.onClickAddButton : null
    const onClickShowButton = typeof props.onClickShowButton === 'function' ? props.onClickShowButton : null
    const onChange = typeof props.onChange === 'function' ? props.onChange : () => { }
    const onInputChange = typeof props.onInputChange === 'function' ? props.onInputChange : () => { }
    const onClick = typeof props.onClick === 'function' ? props.onClick : () => { }
    const autoFocus = Boolean(props.autoFocus) || false
    const helpInfo = props.helpInfo
    const showAvatarsOnMultiple = props.showAvatarsOnMultiple || false

    const initialData = {
        data: dropdownData,
        original: dropdownData,
        showResults: false,
        loading: false,
        dataLoaded: false,
        inputValue: inputValue,
        inputPos: {
            x: null,
            y: null,
            width: null,
            left: null,
            right: null,
            bottom: null,
        },
        request: null,
    }

    const timeout = useRef()

    const [data, setData] = useState(initialData)

    const [selected, setSelected] = useState({
        name: inputValue,
        id: inputIdValue
    })

    const [multiSelected, setMultiSelected] = useState({})

    const [focused, setFocused] = useState(0)

    useOnClickOutside(dropdownRef, () => hideResults())

    useImperativeHandle(ref, () => ({
        getInput: () => {
            return inputRef.current
        },
        dropdownIsVisible: () => {
            return data.showResults && (data.data.length > 0 || data.loading)
        },
        reset: () => {
            resetData()
        },
        removeAll: () => {
            removeAll()
        },
        selectAll: () => {
            selectAll()
        }
    }))

    useEffect(() => {
        if (typeof props.inputValue !== 'undefined') {
            setData(prev => ({
                ...prev,
                inputValue: inputValue
            }))
        }
    }, [props.inputValue, props.inputIdValue])


    useEffect(() => {

        // експериментално, същото го има малко по-надолу
        if (typeof props.inputValue !== 'undefined') {

            setSelected(prev => ({
                ...prev,
                name: inputValue,
                id: inputIdValue
            }))

            setData(prev => ({
                ...prev,
                inputValue: inputValue
            }))

        }

        if (!filter) {
            if (typeof props.inputIdValue !== 'undefined') {

                setSelected(prev => ({
                    ...prev,
                    id: props.inputIdValue
                }))

                // console.log(inputIdName, inputIdValue, inputValue)

                let exists = data.original.find(e => {
                    return String(e[inputIdField]) === String(props.inputIdValue)
                })

                if (!exists) {
                    // да не прави заявка, ако списъка не е видим
                    if (props.preventInitialLoad) {
                        return
                    }

                    clearTimeout(timeout.current)

                    timeout.current = setTimeout(() => {
                        loadData(props.inputValue, props.inputIdValue, rows => {
                            let active = rows.filter((e, i) => {
                                if (String(e[inputIdField]) === String(inputIdValue)) {
                                    setFocused(i)
                                    return true
                                }

                                return false
                            })[0]

                            if (active) {
                                // let el = listRef.current.querySelector("li[data-id='" + active[inputIdField] + "']");

                                // if (el) {
                                //     el.click();
                                // }

                                selectElement(active, false)
                            }
                        })
                    }, filterTimeout)
                } else {
                    // let el = listRef.current.querySelector("li[data-id='" + exists[inputIdField] + "']");

                    // if (el) {
                    //     el.click();
                    // }

                    selectElement(exists, false)
                }

            }
        }
    }, [props.inputValue, props.inputIdValue, props.url])

    // при прост филтър на резултати
    useEffect(() => {
        if (filter) {
            let exists = data.original.filter(e => {
                return e[inputIdField] == inputIdValue
            })[0]

            if (exists) {

                // let el = listRef.current.querySelector("li[data-id='" + exists[inputIdField] + "']");

                // if (el) {
                //     el.click();
                // }

                selectElement(exists, false)

                // setSelected(prev => ({
                //     ...prev,
                //     name: exists.name
                // }))
            } else {
                if (props.inputValue) {
                    setSelected(prev => ({
                        ...prev,
                        name: props.inputValue
                    }))
                }
            }
        }
    }, [props.inputValue, props.inputIdValue, data.original])

    useEffect(() => {
        if (Array.isArray(props.data)) {
            setData(prev => ({
                ...prev,
                data: props.data,
                original: props.data
            }))
        }
    }, [props.data])

    // за multiple
    useEffect(() => {
        if (multiple && typeof props.selectedValues !== 'undefined') {
            let ids = {}

            selectedValues.map(obj => {
                ids[String(obj[inputIdField])] = obj
            })

            setMultiSelected(ids)
        }
    }, [props.selectedValues])

    useEffect(() => {
        if (multiple && data.data.length && typeof props.selectedIds !== 'undefined') {
            let ids = Object.assign({}, multiSelected)

            selectedIds.map(id => {
                let found = data.data.find(el => String(el[inputIdField]) === String(id))

                if (found) {
                    ids[String(id)] = found
                }
            })

            setMultiSelected(ids)
        }
    }, [props.selectedIds, data.data])

    useEffect(() => {
        if (multiple) {
            loadData()
        }
    }, [])

    useEffect(() => {
        if (props.url && multiple && selectedValues.length === 0) {
            setData(prev => ({
                ...prev,
                data: [],
                original: []
            }))
        }
    }, [props.url])

    useEffect(() => {
        return () => clearTimeout(timeout.current)
    }, [])

    useEffect(() => {
        if (typeof props.params !== 'undefined') {

            if (!data.showResults && props.preventInitialLoad) {
                return
            }

            loadData(selected.name, selected[inputIdField])
        }
    }, [props.params])

    useEffect(() => {
        calcDropdownPosition()

        const onResize = e => {
            calcDropdownPosition()
        }

        const onScroll = e => {
            calcDropdownPosition()
        }

        let modal = dropdownContainerRef.current.closest('.modal')

        if (modal) {
            modal.addEventListener('resize', onResize)
            modal.addEventListener('scroll', onScroll)
        } else {
            window.addEventListener('resize', onResize)
            window.addEventListener('scroll', onScroll)
        }

        return () => {
            if (modal) {
                modal.removeEventListener('resize', onResize)
                modal.removeEventListener('scroll', onScroll)
            } else {
                window.removeEventListener('resize', onResize)
                window.removeEventListener('scroll', onScroll)
            }
        }
    }, [dropdownContainerRef.current])

    const loadData = (name, id = null, callback = null) => {
        if (!dataUrl) {
            return
        }

        if (typeof name === 'undefined') {
            name = ''
        }

        // console.log(dataParams)

        if (requiredParams.length) {
            let params = Object.keys(dataParams)

            let missingParams = []

            // console.log(params)
            // console.log(dataParams)

            let hasMissingParams = requiredParams.filter(p => {

                if (params.includes(p) && !dataParams[p]) {
                    missingParams.push(p)

                    return true
                }

                return false
            }).length

            // console.log(hasMissingParams);

            if (hasMissingParams) {
                console.warn(`[Dropdown]: Missing params: ${missingParams.join(', ')}`)
                return false
            }
        }

        if (data.request) {
            data.request.cancel()
        }

        let request = Axios.CancelToken.source()

        setData(prev => ({
            ...prev,
            request: request
        }))

        const reqParams = {
            ...dataParams,
            [dataKeyword]: name,
        }

        if (id) {
            reqParams.id = id
        }
        Api.get(dataUrl, {
            params: reqParams,
            cancelToken: request.token
        }).then(res => {

            let items = typeof res.data.items !== 'undefined' ? res.data.items : typeof res.data.data !== 'undefined' ? res.data.data : res.data

            items = items.map(i => {

                if (!i[inputIdField]) {
                    i[inputIdField] = Math.random().toString().substr(3)
                }

                return i
            })

            setData(prev => ({
                ...prev,
                data: items,
                original: items,
                loading: false,
                dataLoaded: true
            }))

            if (selected[inputIdField]) {
                items.map((e, i) => {
                    if (e[inputIdField] == selected[inputIdField]) {
                        setFocused(i)
                    }
                })
            }

            if (typeof callback === 'function') {
                return callback(items)
            }

        }).catch(err => {
            setData(prev => ({
                ...prev,
                data: [],
                original: [],
                loading: false,
                // showResults: false
            }))
        })

    }

    const calcDropdownPosition = () => {
        let container = dropdownContainerRef.current

        if (!container) {
            return
        }

        const rect = container.getBoundingClientRect()

        setData(prev => ({
            ...prev,
            inputPos: {
                x: rect.x,
                y: rect.y + rect.height,
                left: rect.left,
                right: rect.right,
                bottom: rect.bottom,
                width: rect.width,
            }
        }))
    }

    const handleClickAway = () => {
        hideResults()
    }

    const handleKeyPress = e => {
        // e.preventDefault();
        // e.stopPropagation();

        let action

        if (e.keyCode == 9) {
            action = 'tab'
        } else if (e.keyCode == 40) {
            action = 'down'
        } else if (e.keyCode == 38) {
            action = 'up'
        } else if (e.keyCode == 13) {
            action = 'enter'
        } else if (e.keyCode == 27) {
            action = 'esc'
        }

        if (action === 'esc') {
            if (data.showResults) {
                e.preventDefault()
            }

            return hideResults()
        }

        if (action === 'tab') {
            return
        }

        // if (action === 'down') {
        //     if (!data.showResults) {
        //         showResults();
        //     }
        // }

        if (action && data.showResults) {
            e.preventDefault()

            let val = e.target.value

            // showResults();

            let selectedData = {
                name: val,
                id: ''
            }

            setSelected(selectedData)

            if (action === 'down' || action === 'up') {

                let min = 0
                let max = data.original.length - 1

                let position

                if (action === 'down') {
                    position = focused + 1
                } else {
                    position = focused - 1
                }

                if (position > max) {
                    position = 0
                } else if (position < min) {
                    position = max
                }

                // if (position < min || position > max) {
                //     return;
                // }

                setFocused(position)

                setTimeout(() => {
                    const selectedFocus = listRef.current.querySelector('.focus')

                    if (selectedFocus) {
                        const offsetHeight = selectedFocus.offsetHeight
                        const offsetTop = selectedFocus.offsetTop

                        const scroll = listRef.current.scrollTop
                        const height = listRef.current.offsetHeight

                        if (offsetTop + offsetHeight > scroll + height) {
                            listRef.current.scrollTop = scroll + offsetHeight
                        } else if (offsetTop < scroll) {
                            listRef.current.scrollTop = scroll - offsetHeight
                        }
                    }

                }, 50)

            } else if (action === 'enter') {

                // let selectedFocus = data.original[focused];

                const selectedFocus = listRef.current.querySelector('.focus')

                // не работи, защото се проверяма дали клика е от човек
                // if (selectedFocus) {
                //     selectedFocus.click();
                // }

                if (selectedFocus) {
                    let el = data.data.find(row => String(row[inputIdField]) === selectedFocus.getAttribute('data-id'))

                    if (el) {
                        handleResult(e, el)
                    }
                }

                // if (selectedFocus) {
                //     setSelected({
                //         id: selectedFocus[inputIdField],
                //         name: selectedFocus.name
                //     })

                //     if (props.onChange && typeof props.onChange === 'function') {
                //         props.onChange(selectedFocus);
                //     }

                //     hideResults();
                // }

            }
        }
    }

    const handleClick = e => {
        onClick()

        showResults()
    }

    const handleChange = e => {

        let val = e.target.value

        onInputChange(val)

        if (!filterable) {
            return
        }


        let selectedData = {
            name: val,
            id: ''
        }

        setSelected(selectedData)

        clearTimeout(timeout.current)

        // просто филтриране на данните
        if (filter) {
            timeout.current = setTimeout(() => {

                let filtered = data.original.filter(e => {
                    return e.name ? e.name.indexOf(val) > -1 : true
                })

                setData(prev => ({
                    ...prev,
                    data: filtered,
                    inputValue: val
                }))

                // ако в списъкът има само 1 елемент се избира автоматично
                // if (filtered.length == 1) {
                //     setSelected({
                //         name: filtered[0] ? filtered[0].name : '',
                //         id: filtered[0] ? filtered[0][inputIdField] : ''
                //     });

                //     hideResults();
                // }


                // if (!multiple && onChange && typeof onChange === 'function') {
                //     onChange(selectedData);
                // }

            }, 50)
        }
        // филтриране чрез заявка към база данни
        else {

            if (!dataUrl) {
                return
            }

            // console.log(val)
            // console.log(data.inputValue);

            if (String(val) !== String(data.inputValue)) {

                setData(prev => ({
                    ...prev,
                    loading: true,
                }))

                timeout.current = setTimeout(() => {
                    loadData(val, null, data => {
                        // ако в списъкът има само 1 елемент се избира автоматично
                        // if (data.length == 1) {
                        //     setSelected({
                        //         name: data[0] ? data[0].name : '',
                        //         id: data[0] ? data[0][inputIdField] : ''
                        //     });

                        //     hideResults();
                        // }
                    })

                }, filterTimeout)

                // if (!multiple && onChange && typeof onChange === 'function') {
                //     onChange(selectedData);
                // }

            }

            setTimeout(() => {
                setData(prev => ({
                    ...prev,
                    inputValue: val
                }))
            }, 100)
        }
    }

    const handleResult = (e, el) => {
        e.preventDefault()

        if (e.target.tagName === 'BUTTON') {
            hideResults()
            return
        }

        let target = e.currentTarget

        let input = inputRef.current

        // връщаме фокуса към полето, ако реални има клик от потребителя
        if (e.isTrusted || autoFocus) {
            input.focus()
        }

        if (!e.isTrusted) {
            hideResults()
            return
        }

        selectElement(el)

        if (!multiple) {
            hideResults()
        }
    }

    const selectElement = (el, triggerChange = true) => {
        let id = el[inputIdField]
        let val = getDisplayName(el)

        // пълна информация за избрания елемент от базата данни
        let selectedExtended = data.data.find((e, i) => {
            if (String(e[inputIdField]) === String(id)) {
                setFocused(i)
                return true
            }
            return false
        })

        let selectedData = {
            name: val,
            id: id
        }

        let selectedList
        let shouldCallCallback

        if (multiple) {
            selectedList = Object.assign({}, multiSelected)

            id = String(id)

            if (selectedList[id]) {
                delete selectedList[id]
            } else {
                if (selectedExtended) {
                    selectedList[id] = selectedExtended
                } else {
                    selectedList[id] = selectedData
                }

            }

            shouldCallCallback = true
            setMultiSelected(selectedList)

        } else {
            shouldCallCallback = String(selected[inputIdField]) !== String(id)
            setSelected(selectedData)
        }

        setData(prev => ({
            ...prev,
            inputValue: val
        }))

        if (triggerChange && shouldCallCallback && onChange && typeof onChange === 'function') {
            if (multiple) {
                // console.log(selectedList)
                onChange(Object.values(selectedList))
            } else {
                if (selectedExtended) {
                    onChange(selectedExtended)
                } else {
                    onChange(selectedData)
                }
            }
        }
    }

    const handleBlur = e => {
        if (!e.isTrusted) {
            return
        }

        if (multiple) {
            return
        }

        if (e.nativeEvent.explicitOriginalTarget &&
            e.nativeEvent.explicitOriginalTarget === e.nativeEvent.originalTarget) {
            return
        }

        setTimeout(() => {
            hideResults()
        }, 200)
    }

    const showResults = () => {

        calcDropdownPosition()

        // първоначално зареждане на данните след фокус на полето
        // при последващ фокус не се изпълнява
        if (!data.dataLoaded || loadDataOnFocus) {
            if (dataUrl) {
                clearTimeout(timeout.current)

                timeout.current = setTimeout(() => {
                    loadData(selected.name, selected[inputIdField])
                }, filterTimeout)
            }
        }

        setData(prev => ({
            ...prev,
            showResults: true
        }))
    }

    const hideResults = () => {
        setData(prev => ({
            ...prev,
            showResults: false,
            // inputPos: {
            //     x: null,
            //     y: null,
            //     width: null,
            // }
        }))
    }

    const resetData = () => {
        setSelected({
            name: '',
            id: ''
        })

        setData(initialData)
    }

    const selectAll = () => {
        let selected = {}

        data.data.map(item => {
            selected[String(item[inputIdField])] = item
        })

        setMultiSelected(selected)

        if (onChange && typeof onChange === 'function') {
            onChange(Object.values(selected))
        }
    }

    const removeAll = () => {
        let selected = {}

        setMultiSelected(selected)

        if (onChange && typeof onChange === 'function') {
            onChange(Object.values(selected))
        }
    }

    const removeItem = item => {
        let selected = Object.assign({}, multiSelected)

        let id = String(item[inputIdField])

        delete selected[id]

        setMultiSelected(selected)

        if (onChange && typeof onChange === 'function') {
            onChange(Object.values(selected))
        }
    }

    const getDisplayName = el => {

        if (typeof renderInputText === 'function') {
            return renderInputText(el)
        }

        if (typeof renderText === 'function') {
            return renderText(el)
        }

        return el.name ? el.name : ''
    }

    const getInputValue = () => {
        if (multiple && !filterable) {
            let data = []

            Object.values(multiSelected).map(selected => {
                data.push(
                    getDisplayName(selected)
                )
            })

            return data.join(', ')
        }

        return selected.name
    }

    const getInput = () => {

        return (
            <>
                {/* {onClickAddButton &&
                    <Button
                        size={size}
                        className="add"
                        variant=""
                        onClick={onClickAddButton}
                        style={{ display: 'flex', alignItems: 'center', borderTopLeftRadius: '.25rem', borderBottomLeftRadius: '.25rem' }}
                        disabled={inputDisabled || inputReadOnly || addButtonDisabled}
                        title="Нов"
                        tabIndex={-1}
                    >
                        <Plus />
                    </Button>
                } */}
                <input
                    ref={inputRef}
                    name={inputName}
                    id={inputId}
                    className={[inputClassName, !filterable && 'not-filterable'].join(' ')}
                    value={getInputValue()}
                    placeholder={inputPlaceholder}
                    readOnly={inputReadOnly}
                    disabled={inputDisabled}
                    onFocus={showResults}
                    // onBlur={handleBlur}
                    onChange={handleChange}
                    onClick={handleClick}
                    isInvalid={Boolean(props.error)}
                    size={size}
                    autoComplete="off"
                    role="presentation"
                    autoFocus={autoFocus}
                    type='text'
                />
                {Boolean(props.helperText) &&
                    <div className="invalid-feedback d-block">
                        {props.helperText}
                    </div>
                }
            </>
        )
    }

    const getMultiSelectedList = () => {
        return (
            <div className="multiple-selected">
                {Object.values(multiSelected).length > 0
                    ?
                    Object.values(multiSelected).map(selected =>
                        <div className="item" key={selected[inputIdField]}>
                            <button onClick={e => removeItem(selected)}>
                                &times;
                            </button>
                            <div>
                                {typeof renderText === 'function' ? renderText(selected) : getDisplayName(selected)}
                            </div>
                        </div>
                    )
                    :
                    <p>
                        Няма избрани
                    </p>
                }
            </div>
        )
    }

    const getPosition = () => {
        if (position === 'left' || position === 'start') {
            return {
                top: data.inputPos.bottom,
                left: data.inputPos.left,
                minWidth: data.inputPos.width
            }
        } else if (position === 'right' || position === 'end') {
            return {
                top: data.inputPos.bottom,
                left: 'initial',
                right: window.screen.availWidth - data.inputPos.right,
                minWidth: data.inputPos.width
            }
        }
    }

    return (
        <>
            <div ref={dropdownContainerRef} className="dropdown-input" onKeyDown={handleKeyPress}>

                {getInput()}

                <div ref={dropdownRef} style={{ ...props.listStyle, ...getPosition() }} className={['dropdown', data.showResults && (data.data.length > 0 || data.loading) ? 'show' : ''].join(' ')}>

                    <ul ref={listRef}>
                        {
                            data.loading
                                ?
                                <div style={{ padding: '10px' }}>
                                    <Skeleton height={45} count={5} />
                                </div>
                                :
                                data.data.map((el, i) =>
                                    <React.Fragment key={i}>
                                        <li
                                            data-id={el[inputIdField]}
                                            data-name={el.name}
                                            onClick={e => handleResult(e, el)}
                                            className={[el[inputIdField] && (String(selected[inputIdField]) === String(el[inputIdField]) || multiSelected[el[inputIdField]]) ? 'active' : '', focused == i ? 'focus' : '', multiple ? 'multiple' : ''].join(' ')}
                                        >
                                            {multiple
                                                ?
                                                <>
                                                    <Checkbox
                                                        checked={!!(el[inputIdField] && (String(selected[inputIdField]) === String(el[inputIdField]) || multiSelected[el[inputIdField]]))}
                                                        sx={{
                                                            margin: '-8px',
                                                            marginRight: 0,
                                                        }}
                                                        color='primary'
                                                    />
                                                </>
                                                :
                                                ''
                                            }

                                            {typeof renderText === 'function' ? renderText(el) : el.name}

                                            <div className="display-name" hidden>{getDisplayName(el)}</div>
                                        </li>
                                    </React.Fragment>
                                )
                        }
                    </ul>

                    {onClickAddButton &&
                        <div
                            className={`new ${inputDisabled || inputReadOnly || addButtonDisabled ? 'disabled' : ''}`}
                            onClick={onClickAddButton}
                        >
                            Нов
                        </div>
                    }

                    {multiple && data.data.length > 1 &&
                        <div className="all-options">
                            {/* <ButtonGroup style={{ width: '100%' }}> */}
                            <button className="button-link" onClick={selectAll}>
                                {trans('labels.selectAll')}
                            </button>
                            <button className="button-link" onClick={removeAll}>
                                {trans('buttons.clear')}
                            </button>
                            {/* </ButtonGroup> */}
                        </div>
                    }
                </div>
                {multiple && filterable
                    ?
                    showAvatarsOnMultiple ?
                        <AvatarGroup
                            max={4}
                            sx={{ '& .MuiAvatar-root': { width: 30, height: 30, fontSize: 14, } }}
                        >
                            {Object.values(multiSelected).map((selected, i) =>
                                <Avatar
                                    key={selected[inputIdField]}
                                    alt={selected.name}
                                    avatar={selected.avatar}
                                    sx={{ bgcolor: i === 0 ? "#3BC870" : i === 1 ? "#C471F5" : "#0E61DD" }}
                                >
                                    {selected.name.charAt(0)}
                                </Avatar>
                            )}
                        </AvatarGroup>
                        :
                        <div className="multiple-selected-label">
                            {`${Object.values(multiSelected).length} ${trans('random.selected')}`}
                        </div>
                    :
                    ''
                }


            </div>

            {multiple && filterable && Boolean(withSelectedList)
                ?
                typeof withSelectedList === 'function' && withSelectedList()
                    ?
                    createPortal(
                        getMultiSelectedList(), withSelectedList()
                    )
                    :
                    getMultiSelectedList()
                :
                ''
            }

            {multiple
                ?
                Object.keys(multiSelected).map(id => (
                    <input
                        key={'input-id-value-' + id}
                        type="hidden"
                        name={`${inputIdName}[]`}
                        value={id}
                        // readOnly={inputDisabled}
                        tabIndex={-1}
                    />
                ))
                :
                <input
                    type="hidden"
                    name={inputIdName}
                    value={selected[inputIdField]}
                    // readOnly={inputDisabled}
                    tabIndex={-1}
                />
            }
        </>
    )

}

// export default forwardRef(Index);

export default React.memo(React.forwardRef(Index), (prev, next) => {
    return JSON.stringify(prev) === JSON.stringify(next)
})